module.exports = __webpack_public_path__ + "img/img2.ec5957c9.png";